import GrupoService from "@/services/GrupoService";

export const grupo = {
  namespaced: true,
  state: {
    grupo: {},
  },
  actions: {
    getGrupo({ commit }, payload) {
      return GrupoService.GetGrupo(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postGrupo({ commit }, payload) {
      return GrupoService.PostGrupo(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putGrupo({ commit }, payload) {
      return GrupoService.PutGrupo(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteGrupo({ commit }, payload) {
      return GrupoService.DeleteGrupo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getGrupoOData({ commit }, payload) {
      return GrupoService.GetGrupoOData(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    validate({ commit }, payload) {
      return GrupoService.Validate(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    converter({ commit }, payload) {
      return GrupoService.Converter(payload).then(
        (grupo) => {
          return Promise.resolve(grupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default grupo;
